import { parseQueryString, replaceQueryString } from "@client/lib/api";
import { type GetAssetUrlShort } from "@client/lib/assets";
import { getCurrentUserId } from "@client/lib/cookie";
import { request } from "@client/lib/request";
import { type GenericMap, type I18n, MediaType, type OptionItem } from "@client/types";
import { type ApiInfo } from "@client/types/Api";
import appInfo from "@common/appInfo";
import { mapV1DropdownItem, toOptionItems } from "@common/lib/api";

const getUrl = (path: string, dependencies?: GenericMap<any>, apiInfo?: ApiInfo): string => {
  let url = apiInfo
    ? path
        .replace("${baseUrl}", apiInfo.baseUrl)
        .replace("${hostBaseUrl}", apiInfo.hostBaseUrl ?? "")
        .replace("${apiUrl}", apiInfo.url)
    : path;

  let qs = parseQueryString(url);
  if (!!qs) {
    const params = {
      ...(apiInfo?.baseParams || {}),
      ...(dependencies || {})
    };

    // replaces query string values:
    // 1. foo=    - if foo is in params
    // 2. foo=bar - if bar is in params, bar will be replaced with params[bar]
    Object.keys(qs).forEach((key) => {
      if (qs[key] === "@CurrentUserID") {
        qs[key] = appInfo.user?.id ?? getCurrentUserId() ?? "";
      } else {
        qs[key] = key in params ? params[key] : qs[key] in params ? params[qs[key]] : qs[key];
      }
    });
    url = replaceQueryString(url, qs);
  }

  return url;
};

export const getOptions = <TOption = OptionItem>(
  i18n: I18n,
  path: string,
  apiInfo?: ApiInfo,
  getAssetUrl?: GetAssetUrlShort,
  dependencies?: GenericMap<any>
): Promise<TOption[]> =>
  new Promise((resolve) => {
    const url = getUrl(path, dependencies, apiInfo);

    // TODO: TS issues
    request<any>({ method: "GET", url, cache: "memory", i18n })
      .then((res) => {
        if (res.error) {
          resolve([]);
        } else {
          const items: any = ((res.response!.data || res.response!) as any[]).map<TOption>(
            ({ groupCaption, groupLabel, ...x }) => ({
              ...x,
              image: x.image && getAssetUrl ? getAssetUrl(x.image, MediaType.Image) : x.image
            })
          );
          const data = toOptionItems<any>(items.map(mapV1DropdownItem));
          resolve(data as TOption[]);
        }
      })
      .catch(() => resolve([]));
  });
